const notifications = require('../lib/notifications');

module.exports.submitFormDataOnFormSubmission = function (form, success, unauthorized, forbidden) {

    // submit the form data once the form's submit event fires (after the browser's constraint validation passes)
    registerOnSubmit(form, success, unauthorized, forbidden);

};

module.exports.submitFormDataWithRecaptchaOnFormSubmission = function (form, success, unauthorized, forbidden) {

    // submit the form data once the form's submit event fires (after the browser's constraint validation passes)
    registerOnSubmit(form, success, unauthorized, forbidden);

    // the callback that signals that the form is requested to be submitted; requestSubmit() runs the
    // browser's constraint validation and only fires the submit event if the form is valid
    const onSubmit = function () {
        form.requestSubmit();
    }

    // without a recaptcha site key, the form renders a plain submit button instead of the recaptcha
    // one; wire it to the callback here since the CSP forbids an inline onclick attribute. with a
    // site key, the recaptcha button carries data-callback="onSubmit", which the recaptcha library
    // resolves globally on the window
    const fallbackSubmitButton = form.querySelector('input[type=button].btn-submit:not(.g-recaptcha)');
    if (fallbackSubmitButton) {
        fallbackSubmitButton.addEventListener('click', onSubmit);
    } else {
        window.onSubmit = onSubmit;
    }

};

function registerOnSubmit(form, success, unauthorized, forbidden) {
    form.onsubmit = function (event) {
        event.preventDefault();
        submitProcessedFormData(form, success, unauthorized, forbidden)
        return false;
    }
}

module.exports.submitFormData = function (formData, url, submissionControl, notificationControl, success) {
    submitFormData(formData, url, submissionControl, notificationControl, success || emptySuccess, defaultUnauthorized, defaultForbidden, defaultNotAcceptable, genericUnprocessableEntity)
};

function submitProcessedFormData(form, success, unauthorized, forbidden) {

    const formData = new FormData(form);
    const url = form.getAttribute('action');
    const submissionControl = form.querySelector('input[type=submit], input[type=button].btn-submit');
    const notificationControl = form.getElementsByClassName('notification')[0];

    const unprocessableEntity = function (responseJson) {
        const formElements = form.elements;
        for (let i = 0; i < formElements.length; i++) {
            const formElement = formElements[i];
            const formElementName = formElement.name;
            if (formElementName in responseJson.errors) {
                formElement.focus();
                return responseJson.errors[formElementName].join('<br>');
            }
        }
        return genericUnprocessableEntity(responseJson);
    };

    submitFormData(formData, url, submissionControl, notificationControl, success, unauthorized || defaultUnauthorized, forbidden || defaultForbidden, defaultNotAcceptable, unprocessableEntity);

}

function submitFormData(formData, url, submissionControl, notificationControl, success, unauthorized, forbidden, notAcceptable, unprocessableEntity) {

    function showSuccess(successMessage) {
        if (successMessage) {
            notifications.showSuccess(successMessage, notificationControl);
        }
    }

    function showError(errorMessage) {
        if (errorMessage) {
            notifications.showFailure(errorMessage, notificationControl);
        }
    }

    submissionControl.disabled = true;

    const xhr = new XMLHttpRequest();
    xhr.open('POST', url);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.onload = function () {
        submissionControl.disabled = false;
        if (xhr.status === 200) {
            showSuccess(success(xhr.responseText));
        } else if (xhr.status === 401) {
            showError(unauthorized());
        } else if (xhr.status === 403) {
            showError(forbidden());
        } else if (xhr.status === 406) {
            showError(notAcceptable());
        } else if (xhr.status === 422) {
            showError(unprocessableEntity(JSON.parse(xhr.responseText)));
        } else {
            showError('Die Aktion ist fehlgeschlagen (' + xhr.status + ')' + '.');
        }
    };
    xhr.onerror = function () {
        submissionControl.disabled = false;
        showError('Es ist ein Fehler aufgetreten (' + xhr.status + ').');
    };
    xhr.send(formData);

}

const emptySuccess = function () {
};

const defaultUnauthorized = function () {
    return 'Der Benutzer ist nicht angemeldet.';
};

const defaultForbidden = function () {
    return 'Der Benutzer verfÃ¼gt nicht Ã¼ber die erforderlichen Berechtigungen.';
};

const defaultNotAcceptable = function () {
    return 'Der Benutzer ist nicht menschlich.';
}

const genericUnprocessableEntity = function (responseJson) {
    for (let error in responseJson.errors) {
        return responseJson.errors[error].join('<br>');
    }
};
